export const version = "local" as string;
export const build = "source" as "source" | "esm" | "cjs";
